


















































































































import { Component, Vue, Inject } from 'vue-property-decorator'
import iView from 'iview';
import Ajax from '../../../lib/ajax'
import AbpBase from '../../../lib/abpbase'
import ContractAddForm from './contractAddForm.vue'
import Util from '../../../lib/util'
import Appconst from '../../../lib/appconst'
@Component({
    name:'contractOutDetail',
    components: {
        ContractAddForm
    }
})

export default class ContractOutDetail extends AbpBase  {
    initData:any = {
        detailData: {
            contraceCode: null
        },
        editData: {
            content: {},
            status: false,
            loading: true,
            btnLoading: true,
            contractMainType: 4
        },
        verifyData: {
            status: false,
        },
        showAudit: false,
        invalid:{
            loading:false,
            nullifyRemark: ''
        },
        fileUrl: Appconst.fileUrl,
        addAgreement: {
            status: false,
            btnLoading: true,
            content: {}
        },
    }
    //作废弹窗
    InvalidModal(){
        this.initData.invalid.loading = !this.initData.invalid.loading;
    }
    async InvalidBtn(){
        await Ajax.post('/api/services/app/Contract/ContractNullifyAsyncc',{id:this.initData.id,nullifyRemark:this.initData.nullifyRemark});
        this.$Modal.success({
            title: '提示',
            content: '作废成功！'
        });
        this.GetData();
    }
    //审核弹窗
    VerifyModal() {
        this.initData.verifyData.status = true;
    }
    //合同登记弹窗-关闭回调
    AddModalClose(status:any){
        this.initData.editData.btnLoading = status;
    }
    //补充协议
    AddAgreementModalClose(status:any){
        this.initData.addAgreement.btnLoading = status;
    }
    //审核弹窗-操作
    async VerifyModalAction(type:any) {
        let data:any = {
            catalog: 4,
            isAuditPass: !!type,
            contractId: this.initData.detailData.id,
            contractCode: this.initData.verifyData.contractCode
        };
        this.initData.verifyData.status = false;
        if(type){
            await Ajax.post('/api/services/app/Contract/ContractAuditAsync', data).then((res:any)=>{
                this.$Modal.success({
                    title: '合同登记审核',
                    content: '合同审核通过，已为该合同分配唯一编号：' + res.data.result.contraceCode
                });
                this.GetData();
            });
        }else{
            this.$Modal.confirm({
                title: '合同登记审核',
                content: '确定要驳回该合同吗？',
                onOk: async ()=>{                        
                    await Ajax.post('/api/services/app/Contract/ContractAuditAsync', data).then(()=>{
                        this.$Message.success('操作成功!');
                    })
                    this.GetData();
                }
            })
        }
    }
    CloseAddAgreementModal(status:any){
        this.initData.addAgreement.status = status;
    }
    //合同登记弹窗-关闭
    CloseAddModal(status:any){
        this.initData.editData.status = status;
    }
    //编辑弹窗
    async EditModal() {
        this.initData.editData.content = (this as any).$root.copyObj(this.initData.detailData);
        this.initData.editData.content.contractSignUserId = this.initData.editData.content.contractSignUser?this.initData.editData.content.contractSignUser.id:'';
        this.initData.editData.content.externalUnitId = this.initData.editData.content.externalUnit?this.initData.editData.content.externalUnit.id:null;
        this.initData.editData.content.secondBelongOrgId = this.initData.editData.content.secondBelongOrg ? this.initData.editData.content.secondBelongOrg.id : undefined;
        this.initData.editData.status = true;
        this.initData.editData.loading = false;
    }
    //编辑弹窗提交
    Submit(type:any) {
        (this as any).$refs.ContractAddForm.Submit(type);
    }
    //详情切换
    SwitchContractOutsideDetail(name:any) {
        this.$router.push({
            name: name,
            query: {
                id: this.initData.id,
                contractName: this.initData.detailData.contractName
            }
        });
    }
    //补充协议弹窗
    EditAddAgreement() {
        this.initData.addAgreement.content = Util.extend(true, {}, this.initData.detailData);
        console.log(this.initData.addAgreement.content)
        this.initData.addAgreement.status = true;
        this.initData.addAgreement.loading = false;
    }
    SubmitAgree(){
        (this.$refs.ContractAddFormAgree as any).Submit('add');
    }
    //补充协议
    ToSupplement(id:any){
        this.$router.push({
            name: 'contractOutsideAgreementDetail',
            query: {
                id: id
            }
        })
    }
    async GetDic() {
        //获取当前用户权限
        await this.$store.dispatch('session/init');
        this.initData.showAudit = this.$store.state.user.userInfo.auth.grantedPermissions['Pages.CAndMManager.C.Audit'];
        this.initData.allowEdit = this.$store.state.user.userInfo.auth.grantedPermissions['Pages.CAndMManager.C.MaintainAudited'];
        this.initData.allowNullify = this.$store.state.user.userInfo.auth.grantedPermissions['Pages.CAndMManager.C.Nullify'];
    }
    //获取数据
    async GetData() {
        this.initData.detailData = (await Ajax.get('/api/services/app/Contract/GetExternalDetailInfoAsync?id=' + this.initData.id)).data.result;
    }
    async mounted() {
        this.initData.id = this.$route.query.id;
        await this.GetDic();
        this.GetData();
    }
}
